/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rename_Key_InvalidInputs */

const en_rename_key_invalid = /** @type {(inputs: Rename_Key_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use 2 to 10 characters: letters and digits, starting with a letter.`)
};

const de_rename_key_invalid = /** @type {(inputs: Rename_Key_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutze 2 bis 10 Zeichen: Buchstaben und Ziffern, beginnend mit einem Buchstaben.`)
};

/**
* | output |
* | --- |
* | "Use 2 to 10 characters: letters and digits, starting with a letter." |
*
* @param {Rename_Key_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rename_key_invalid = /** @type {((inputs?: Rename_Key_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rename_Key_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rename_key_invalid(inputs)
	return en_rename_key_invalid(inputs)
});